<template>
    <span>
        <gj-tooltip v-if="data.sku" :text-line="2" :content="data.sku">
            {{data.sku}}
        </gj-tooltip>
        <gj-tooltip v-else content="关联产品">
            <gj-link @click="relateProduct(data.msku, data.marketId)">
              <gj-icon iconfont="iconguanlian" style="font-size: 20px;"></gj-icon>
            </gj-link>
        </gj-tooltip>
    </span>
</template>
<script>
    import AppRelateProductModal from "@/views/layout/components/modal/relate-product-modal/relate-product-modal.vue";

    export default {
        name: "relate-product",
        props: {
            data: Object
        },
        methods: {
            /**
             * 关联产品
             * @param msku msku
             * @param marketId marketId
             */
            relateProduct(msku, marketId) {
                const vm = this;
                let $parent = vm.$route.matched[0].instances.default
                const modal = this.$gjCreate(AppRelateProductModal, {
                    props: {
                        newCompatibilityApi:true,
                        msku,
                        marketId
                    },
                    mountTo: document.querySelector('.base-main'),
                    on: {
                        after() {
                            $parent.$gjResetPage();
                            modal.$gjDestroy();
                        }
                    }
                })
            },

        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>
